
<template>
<div id="layout_apendices" >
    <div>
        <v-breadcrumbs :items="parametrosAPMercancias.breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Matriz RRNA" class="px-5 py-3" >
                <br />
                <v-tabs grow style="margin-bottom: 30px">
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab :key="'in-mercancias'">Sección 1: FA-Mercancía</v-tab>
                    <v-tab :key="'in-casos'">Sección 2: Matriz de Casos</v-tab>
                    
                    <v-tab-item :key="'in-mercancias'">
                        <v-card-text>     
                            <v-card-actions>
                                
                                <v-spacer></v-spacer>
                                <v-speed-dial direction="left" open-on-hover>
                                    <template v-slot:activator>
                                        <v-btn x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>
                                    </template>
                                    <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered1" :exportFields="parametrosAPMercancias.camposexcel" :name="parametrosAPMercancias.title + '.xlsx'" >
                                        <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    <upload-excel-component :on-success="handleSuccessAPMercancias" :before-upload="beforeUpload" />
                                    <exportar-excel :data="parametrosAPMercancias.camposLayout" :exportFields="parametrosAPMercancias.encabezadoLayout" :name="'Layout ' + parametrosAPMercancias.title + '.xlsx'" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-speed-dial>&nbsp;
                                
                                <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModalAPMercancias(1)" title="Agregar Registro" v-tippy>
                                    <v-icon dark>add</v-icon>
                                </v-btn>
                            </v-card-actions>
                            <div class="contenedor-tab-reportes" >
                                <v-client-table ref="vuetable1" :data="datosAPMercancias.items" :columns="parametrosAPMercancias.columns" :options="parametrosAPMercancias.options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistroAPMercancias(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistroAPMercancias(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                            </div>                   
                        </v-card-text>
                    </v-tab-item>

                    <v-tab-item :key="'in-casos'">
                        <v-card-text>                        
                            <v-card-actions>
                                
                                <v-spacer></v-spacer>
                                <v-speed-dial direction="left" open-on-hover>
                                    <template v-slot:activator>
                                        <v-btn x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>
                                    </template>
                                    <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered2" :exportFields="parametrosAPCasos.camposexcel" :name="parametrosAPCasos.title + '.xlsx'" >
                                        <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    <upload-excel-component :on-success="handleSuccessAPCasos" :before-upload="beforeUpload" />
                                    <exportar-excel :data="parametrosAPCasos.camposLayout" :exportFields="parametrosAPCasos.encabezadoLayout" :name="'Layout ' + parametrosAPCasos.title + '.xlsx'" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-speed-dial>&nbsp;
                                
                                <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModalAPCasos(1)" title="Agregar Registro" v-tippy>
                                    <v-icon dark>add</v-icon>
                                </v-btn>
                            </v-card-actions>
                            <div class="contenedor-tab-reportes" >
                                <v-client-table ref="vuetable2" :data="datosAPCasos.items" :columns="parametrosAPCasos.columns" :options="parametrosAPCasos.options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistroAPCasos(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistroAPCasos(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                            </div>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>                    
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modalAPMercancias" max-width="50%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar FA-Mercancía' : 'Nueva FA-Mercancía'" tipo="modal" />
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modalAPMercancias = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardarAPMercancias()" >
                        <v-layout row wrap v-for="(item, index) in this.parametrosAPMercancias.form" :key="index" >
                            <v-flex s12 m6 l6>
                                <v-text-field :name="item" :label="item.label" type="text" v-model="item.value" 
                                v-on:keydown.enter.prevent='1'
                                @input="item.value = item.value.toUpperCase()" :rules="item.requiered ? [rules.required] : []" :maxlength="item.maxlen" ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalAPMercancias = false" >
                    <v-icon>cancel</v-icon>Cancelar
                </v-btn>
                <v-btn color="success" :loading="loading" @click.native="guardarAPMercancias()" >
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalAPCasos" max-width="50%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Matriz de Caso' : 'Nueva Matriz de Caso'" tipo="modal" />
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modalAPCasos = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardarAPCasos()" >
                        <v-layout row wrap v-for="(item, index) in this.parametrosAPCasos.form" :key="index" >
                            <v-flex s12 m6 l6>
                                <span v-if="item.date == true">
                                    <v-menu offset-x ref="item.menu" v-model="item.menu" :close-on-content-click="false" transition="scale-transition" min-width="190px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                            <v-text-field clearable v-on="on" v-model="item.value" :label="item.label" color="secondary" prepend-icon="event" @blur="item.value = parseDate(item.value)" v-mask="'####-##-##'"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="item.value" color="secondary" scrollable locale="es-mx" @input="item.menu = false">
                                            <v-spacer />
                                            <v-btn color="secondary" x-small @click="item.menu = false" >Cancelar</v-btn>
                                        </v-date-picker>
                                    </v-menu>                                   
                                </span>
                                <span v-else>
                                    <v-text-field :name="item" :label="item.label" type="text" v-model="item.value" 
                                    v-on:keydown.enter.prevent='1'
                                    @input="item.value = item.value.toUpperCase()" :rules="item.requiered ? [rules.required] : []" :maxlength="item.maxlen" ></v-text-field>
                                </span>
                                
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalAPCasos = false" >
                    <v-icon>cancel</v-icon>Cancelar
                </v-btn>
                <v-btn color="success" :loading="loading" @click.native="guardarAPCasos()" >
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
    data: () => ({
        URLMercancias:"",
        URLCasos:"",        
        fab: false,        
        name: "datagrid",
        importData: [],
        show_loading: true,
        loading: false,        
        modalAPMercancias: false,
        modalAPCasos: false,          
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,        
        datosAPMercancias: {
            items: []
        },
        datosAPCasos: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        parametros: {},
        clientes: [],        
        parametrosAPMercancias: {
            visible:false,
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 36,
            title: "Matriz de Mercancías",
            columns: [
                "fraccion",
                "numero_identificacion",
                "descripcion",
                "adicional_1",
                "adicional_2",
                "actions"
            ],
            options: {
                filterable: [
                    "fraccion",
                    "numero_identificacion",
                    "descripcion",
                    "adicional_1",
                    "adicional_2",
                ],
                headings: {
                    fraccion: "Fracción",
                    numero_identificacion: "Números Identificación",
                    descripcion: "Descripción",
                    adicional_1: "Adicional 1",
                    adicional_2: "Adicional 2",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                fraccion: "fraccion",
                numero_identificacion: "numero_identificacion",
                descripcion: "descripcion",
                adicional_1: "adicional_1",
                adicional_2: "adicional_2",
            },
            encabezadoLayout: {
                fraccion: "fraccion",
                numero_identificacion: "numero_identificacion",
                descripcion: "descripcion",
                adicional_1: "adicional_1",
                adicional_2: "adicional_2",                
            },
            camposLayout: [{
                fraccion: "[Fracción Arancelaria]",
                numero_identificacion: "[Número de Identificación]",
                descripcion: "[Descripción Mercancía]",
                adicional_1: "[Campo Adicional - Opcional]",
                adicional_2: "[Campo Adicional - Opcional]",
            },{
                fraccion: "[La información debe comenzar en esta fila - 3er fila]",
            }],
            model: {
                id: 0,
                fraccion: "", 
                numero_identificacion: "",
                descripcion: "",
                adicional_1: "",                
                adicional_2: "",
                cliente: "",
            },
            form: {
                fraccion: {
                    requiered: true,
                    label: "Fracción",
                    value: "",
                    maxlen: 8
                },
                numero_identificacion: {
                    requiered: true,
                    label: "Número Identificación",
                    value: "",
                    maxlen: 255
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 255
                },
                adicional_1: {
                    requiered: false,
                    label: "Adicional 1",
                    value: "",
                    maxlen: 255
                },
                adicional_2: {
                    requiered: false,
                    label: "Adicional 2",
                    value: "",
                    maxlen: 255
                },
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        },
        parametrosAPCasos: {
            visible:false,
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 37,
            title: "Matriz de Casos",
            columns: [
                "fraccion",
                "numero_identificacion",
                "descripcion",
                "fecha_inicial",
                "fecha_final",
                "complemento_caso",
                "clave_caso",
                "identificador_caso",
                "clave_permiso",
                "numero_permiso",
                "firma_descargo",                
                "actions"
            ],
            options: {
                filterable: [
                    "fraccion",
                    "numero_identificacion",
                    "descripcion",
                    "fecha_inicial",
                    "fecha_final",
                    "complemento_caso",
                    "clave_caso",
                    "identificador_caso",
                    "clave_permiso",
                    "numero_permiso",
                    "firma_descargo",                                 
                ],
                headings: {
                    fraccion: "Fracción",
                    numero_identificacion: "Número Identificación o Modelo",
                    descripcion: "Descripción",
                    fecha_inicial: "Fecha Inicial",
                    fecha_final: "Fecha Final",
                    complemento_caso: "Complemento Caso",
                    clave_caso: "Clave Caso",
                    identificador_caso: "Identificador Caso",
                    clave_permiso: "Clave Permiso",
                    numero_permiso: "Numero Permiso",
                    firma_descargo: "Firma Descargo",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                fraccion: "fraccion", 
                numero_identificacion: "numero_identificacion",
                descripcion: "descripcion",
                fecha_inicial: "fecha_inicial",
                fecha_final: "fecha_final",
                complemento_caso: "complemento_caso",
                clave_caso: "clave_caso",
                identificador_caso: "identificador_caso",
                clave_permiso: "clave_permiso",
                numero_permiso: "numero_permiso",
                firma_descargo: "firma_descargo",
            },
            encabezadoLayout: {
                fraccion: "fraccion", 
                numero_identificacion: "numero_identificacion",
                descripcion: "descripcion",
                fecha_inicial: "fecha_inicial",
                fecha_final: "fecha_final",
                complemento_caso: "complemento_caso",
                clave_caso: "clave_caso",
                identificador_caso: "identificador_caso",
                clave_permiso: "clave_permiso",
                numero_permiso: "numero_permiso",
                firma_descargo: "firma_descargo",
            },
            camposLayout: [{
                fraccion: "[Fracción Arancelaria]", 
                numero_identificacion: "[Número de Identificación o Modelo]",
                descripcion: "[Descripción Mercancía]",
                fecha_inicial: "[Fecha Inicial en formato AAAA-MM-DD]",
                fecha_final: "[Fecha Final en formato AAAA-MM-DD]",
                complemento_caso: "[Complemento de Caso]",
                clave_caso: "[Clave de Caso]",
                identificador_caso: "[Identificador de Caso]",
                clave_permiso: "[Clave de Permiso]",
                numero_permiso: "[Número de Permiso]",
                firma_descargo: "[Firma de Descargo]",               
            },{
                fraccion: "[La información debe comenzar en esta fila - 3er fila]", 
                }],
            model: {
                id: 0,
                fraccion: "", 
                numero_identificacion: "",
                descripcion: "",
                fecha_inicial: "",
                fecha_final: "",
                complemento_caso: null,
                clave_caso: null,
                identificador_caso: null,
                clave_permiso: null,
                numero_permiso: null,
                firma_descargo: null,
                cliente: "",
            },
            form: {
                fraccion: {
                    requiered: true,
                    label: "Fracción",
                    value: "",
                    maxlen: 8
                },
                numero_identificacion: {
                    requiered: true,
                    label: "Número Identificación o Modelo",
                    value: "",
                    maxlen: 255
                },           
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 255
                },
                fecha_inicial: {
                    requiered: false,
                    label: "Fecha Inicial",
                    value: "",
                    maxlen: 10,
                    menu: false,
                    date: true
                },
                fecha_final: {
                    requiered: false,
                    label: "Fecha Final",
                    value: "",
                    maxlen: 10,
                    menu: false,
                    date: true
                },
                complemento_caso: {
                    requiered: false,
                    label: "Complemento Caso",
                    value: null,
                    maxlen: 255
                },
                clave_caso: {
                    requiered: false,
                    label: "Clave Caso",
                    value: null,
                    maxlen: 255
                },
                identificador_caso: {
                    requiered: false,
                    label: "Identificador Caso",
                    value: null,
                    maxlen: 255
                },
                clave_permiso: {
                    requiered: false,
                    label: "Clave Permiso",
                    value: null,
                    maxlen: 255
                },
                numero_permiso: {
                    requiered: false,
                    label: "Número Permiso",
                    value: null,
                    maxlen: 255
                },
                firma_descargo: {
                    requiered: false,
                    label: "Firma Descargo",
                    value: null,
                    maxlen: 255
                },
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        },
    }),
    components: {
        "v-power-titulo": powerTitulo,
        "v-menu-lateral-apendice": menuLateral
    },
    computed: {
        datafiltered1() {
            if (this.$refs.vuetable1 != null) {
                return this.$refs.vuetable1.allFilteredData;
            } else {
                return this.datosAPMercancias.items;
            }
        },
        datafiltered2() {
            if (this.$refs.vuetable2) {
                return this.$refs.vuetable2.allFilteredData;
            } else {
                return this.datosAPCasos.items;
            }
        }
    },
    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModalAPMercancias: function (type) {
            if (type === 1) {
                this.limpiarModelAPMercancias();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modalAPMercancias = true;
        },
        openModalAPCasos: function (type) {
            if (type === 1) {
                this.limpiarModelAPCasos();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modalAPCasos = true;
        },
        limpiarModelAPMercancias: function () {
            for (var k in this.parametrosAPMercancias.model) {
                this.parametrosAPMercancias.model[k] = "";
            }
            for (var k in this.parametrosAPMercancias.model) {
                if (Object.keys(this.parametrosAPMercancias.form).includes(k))
                    this.parametrosAPMercancias.form[k].value = "";
            }            
        },        
        limpiarModelAPCasos: function () {
            for (var k in this.parametrosAPCasos.model) {
                this.parametrosAPCasos.model[k] = "";
            }
            for (var k in this.parametrosAPCasos.model) {
                if (Object.keys(this.parametrosAPCasos.form).includes(k))
                    this.parametrosAPCasos.form[k].value = "";
            }            
        },        
        guardarAPMercancias() {
            var datos = this.parametrosAPMercancias.model;
            datos["tabla"] = this.parametrosAPMercancias.tabla;
            let id_cliente = this.$local_storage.get("id_cliente");
            var obj = this.parametrosAPMercancias.form;
            for (var [key, valores] of Object.entries(obj)) {
                if (valores.value != undefined && valores.value != null && valores.value != ""){
                    datos[key] = valores.value;
                } else {
                    datos[key] = null;
                }                
                datos["cliente"] = id_cliente == 0 ? null : id_cliente;
            }

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URLMercancias;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.parametrosAPMercancias.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargarMercancias();
                        this.$root.$dialogLoader.hide();
                        this.modalAPMercancias = false;
                    });
            }
        },
        guardarAPCasos() {
            var datos = this.parametrosAPCasos.model;
            datos["tabla"] = this.parametrosAPCasos.tabla;
            let id_cliente = this.$local_storage.get("id_cliente");
            var obj = this.parametrosAPCasos.form;
            for (var [key, valores] of Object.entries(obj)) {
                if (valores.value != undefined && valores.value != null && valores.value != ""){
                    datos[key] = valores.value;
                } else {
                    datos[key] = null;
                }
               
                datos["cliente"] = id_cliente == 0 ? null : id_cliente;
            }

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URLCasos;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.parametrosAPCasos.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargarCasos();
                        this.$root.$dialogLoader.hide();
                        this.modalAPCasos = false;
                    });
            }
        },        
        cargarMercancias: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            var datos = {
                tabla: this.parametrosAPMercancias.tabla,                
            };
            
            datos["cliente"]= this.id_cliente;

            axios
                .post(this.$hostname + this.parametrosAPMercancias.url_list, datos)                
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datosAPMercancias.items = res.data;                        
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                })
                .then(() => {
                    this.cargarCasos();
                });
        },   
        cargarCasos: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            var datos = {
                tabla: this.parametrosAPCasos.tabla,                
            };
            
            datos["cliente"]= this.id_cliente;

            axios
                .post(this.$hostname + this.parametrosAPCasos.url_list, datos)                
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datosAPCasos.items = res.data;                        
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },                
        getRegistroAPMercancias: function (id_registro) {
            let tabla = this.parametrosAPMercancias.tabla;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URLMercancias + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.parametrosAPMercancias.model = response.data;
                    var obj = response.data;
                    for (var [key, value] of Object.entries(obj)) {
                        if (Object.keys(this.parametrosAPMercancias.form).includes(key))
                            this.parametrosAPMercancias.form[key].value = value;
                    }
                    this.openModalAPMercancias(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getRegistroAPCasos: function (id_registro) {
            let tabla = this.parametrosAPCasos.tabla;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URLCasos + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.parametrosAPCasos.model = response.data;
                    var obj = response.data;
                    for (var [key, value] of Object.entries(obj)) {
                        if (Object.keys(this.parametrosAPCasos.form).includes(key))
                            this.parametrosAPCasos.form[key].value = value;
                    }
                    this.openModalAPCasos(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        
        deleteRegistroAPMercancias: function (id_registro) {
            let tabla = this.parametrosAPMercancias.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                        .delete(this.URLMercancias + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargarMercancias();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            console.log(error);
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        deleteRegistroAPCasos: function (id_registro) {
            let tabla = this.parametrosAPCasos.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                        .delete(this.URLCasos + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargarMercancias();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            console.log(error);
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        
        handleSuccessAPMercancias({
            results,
            header
        }) {
            for (var k in results) {
                results[k]['cliente'] = this.id_cliente;
                //console.log("Key is " + k + ", value is" + results[k]);  
            }            
            this.importData = results;
            this.$nextTick(() => {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            });
            
            let tabla = this.parametrosAPMercancias.tabla;
            axios
                .post(this.$hostname + "apendices/importar_apendice/?tabla=" + tabla, this.importData)                
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Los datos se guardaron correctamente",
                        footer: ""
                    });
                })
                .catch(err => {
                    var errores = "";
                    if (typeof err.response.data != "undefined") {
                        for (var i = 0; i < err.response.data.length; i++) {
                            Object.keys(err.response.data[i]).forEach(function (key) {
                                errores +=
                                    "Fila " +
                                    (i + 3) +
                                    " => " +
                                    key +
                                    ": " +
                                    err.response.data[i][key];
                                errores += "<br>";
                            });
                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                        footer: errores
                    });
                })
                .then(() => {                    
                    this.cargarMercancias();                    
                });
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        handleSuccessAPCasos({
            results,
            header
        }) {
            for (var k in results) {
                results[k]['cliente'] = this.id_cliente;
                if ('fecha_inicial' in results[k] && results[k]['fecha_inicial'].toString().trim()==""){
                    delete(results[k]['fecha_inicial'])
                } else if('fecha_inicial' in results[k] && results[k]['fecha_inicial'].toString().trim()!="" && results[k]['fecha_inicial'].toString().trim()!=false) {
                    results[k]['fecha_inicial'] = this.parseDateExcel(results[k]["fecha_inicial"])
                }
                if ('fecha_final' in results[k] && results[k]['fecha_final'].toString().trim()==""){
                    delete(results[k]['fecha_final'])
                } else if('fecha_final' in results[k] && results[k]['fecha_final'].toString().trim()!="" && results[k]['fecha_final'].toString().trim()!=false) {
                    results[k]['fecha_final'] = this.parseDateExcel(results[k]["fecha_final"])
                }
                //console.log("Key is " + k + ", value is" + results[k]);  
            }            
            this.importData = results;
            this.$nextTick(() => {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            });
            
            let tabla = this.parametrosAPCasos.tabla;
            axios
                .post(this.$hostname + "apendices/importar_apendice/?tabla=" + tabla, this.importData)                
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Los datos se guardaron correctamente",
                        footer: ""
                    });
                })
                .catch(err => {
                    var errores = "";
                    if (typeof err.response.data != "undefined") {
                        for (var i = 0; i < err.response.data.length; i++) {
                            Object.keys(err.response.data[i]).forEach(function (key) {
                                errores +=
                                    "Fila " +
                                    (i + 3) +
                                    " => " +
                                    key +
                                    ": " +
                                    err.response.data[i][key];
                                errores += "<br>";
                            });
                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                        footer: errores
                    });
                })
                .then(() => {                    
                    this.cargarMercancias();                    
                });
        },
               
    }, //methods

    created: function () {
        this.id_cliente = this.$local_storage.get("id_cliente");
        
        this.URLMercancias = this.$hostname + this.parametrosAPMercancias.url_actions;        
        this.URLCasos = this.$hostname + this.parametrosAPCasos.url_actions;        
        
        this.editable = false;            
        this.cargarMercancias();        
                
    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
</style>
